import { number, string, arrayOf } from 'prop-types';
import styled from 'styled-components';
import { useDropzone } from 'react-dropzone';
import { nanoid } from 'nanoid';
import Button from '../../StoraEnsoComponents/Button';
import { ReactComponent as UploadSvg } from '../../../assets/icons/upload-solid.svg';
import NotificationToast from '../../NotificationToast';
import { useState } from 'react';

const UploadIcon = styled(UploadSvg)`
  width: 28px;
  height: auto;
  fill: ${({ theme }) => theme.colors.text_dark};
  margin-bottom: 1rem;
`;

const ActiveOverlay = styled.div`
  background-color: ${({ theme }) => theme.colors.bg_gray_light};
  display: flex;
  padding: 1rem;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
`;

const DropzoneBorder = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
  border-width: 3px;
  border-style: ${({ isDragActive }) => (isDragActive ? 'solid' : 'dashed')};
  border-color: red;
  border-color: ${({ theme }) => theme.colors.bg_gray_dark};
`;

const Separator = styled.span`
  font-weight: bold;
  margin-bottom: 1rem;
`;

// TODO
// - handle file duplicity
function FileUpload({ maxFileSize, acceptedFileTypes, onChange }) {

  const [actionResult,setActionResult] = useState(null)
  const onDrop = (acceptedFiles) => {
    if(acceptedFiles.length===0){
      acceptedFiles=[]
      setActionResult({
        kind: 'error',
        message: 'You selected unsupported file type. \n' +
                 'Only JPG and mp4 file are supported. \n' +
                 'Max file size is 2 Gb. \n'

      });
    }
    const videoCheck = acceptedFiles.filter(f=>f.type==='video/mp4')
    if (videoCheck.length>1){
      acceptedFiles=[]
      setActionResult({
        kind: 'error',
        message: 'Only one video file is enabled \n'

      });
    }
    onChange(acceptedFiles.map(file => ({
      id: nanoid(),
      file,
      uploadStatus: {
        status: 'idle',
        loaded: 0,
      }
    })));
  }

  const {isDragActive, open, getRootProps, getInputProps} = useDropzone({
    accept: acceptedFileTypes,
    maxSize: maxFileSize,
    noClick: true,
    onDrop: onDrop,
  });

  return (
    <>
      <NotificationToast
        toastId="fileUpload"
        kind={actionResult?.kind}
        message={actionResult?.message}
        onClose={() => setActionResult(null)}
      />

      <DropzoneBorder {...getRootProps()} isDragActive={isDragActive}>
        {isDragActive && (
          <ActiveOverlay>
            Drop files here.
          </ActiveOverlay>
        )}
        <input {...getInputProps()} />
        <UploadIcon />
        <p>Drag and drop files here</p>
        <Separator>OR</Separator>
        <Button kind="attention" onClick={open}>Select files</Button>
      </DropzoneBorder>
    </>
  );
}

FileUpload.propTypes = {
  maxFileSize: number,
  acceptedFileTypes: arrayOf(string),
};

FileUpload.defaultProps = {
  maxFileSize: 2000000000,
  acceptedFileTypes: [
    'image/*','video/mp4'
  ],
};

export default FileUpload;